import React, { useEffect, useMemo, useState } from "react";
import { Prompt, useHistory, useLocation, } from "react-router-dom";
import Select, { components } from "react-select";
import { TABLE_ROWS_PER_PAGE, } from "../../../../../utils/Constants";
import { tokens } from "../../../../../public/tokens";
import PermissionsGate from "../../../../../utils/permissionGate";

import ExcelJS from 'exceljs';
import JsPDF from "jspdf";
import "jspdf-autotable";
import moment from "moment";
import Papa from "papaparse";
import { useRef } from "react";
import { pdf } from "@react-pdf/renderer";
import Swal from "sweetalert2";
import * as XLSX from "xlsx";
import { useQueryClient } from "@tanstack/react-query";
import { usePermissionGuardRedirect } from "../../../../../hooks/usePermissionGuard";
import useDebounce from "../../../../../hooks/useDebounce";
import { getStudentBrand, getStudentGradebookCancelToken, updateCousesScore, updatePmcScoreCancelToken } from "../../../../../services/GradeSettingService";
import { GetAssignedSubjectCancelToken } from "../../../../../services/StudentsSettingServices";
import { getProgrammeModulesGradeStudentList, exportGradebookExcel, getGradebookOriginIntakes, getGradebookProgrammeCode } from "../../../../../services/ProgrammeServices";
import { RenderLearningMethodGradebook } from "../../../../../utils/CommonGroupingItem";
import { RenderQuizAttemptResultStatus } from "../../../../../utils/CommonStatusItems";
import Tablefilter from "../../../../common/Tablefilter";
import Button from "../../../../library/Button";
import FloatingActionBar from "../../../../library/FloatingActionBar";
import ProgressCard from "../../../../library/ProgressCard";
import ToggleSwitch from "../../../../library/ToggleSwitch";
import GradebookSuccessBanner from "./GradebookSuccessBanner";
import LetterHeadPDF3 from "../../../../../LetterHeadPDF3";
import { useProgrammeSummary } from "../../../../../query/hooks/QueryHooksProgramDetail";
import {
    studentGradeListQueryKey,
    useIntakeAndGraduationDropdownFilters,
    useModuleColumnHeaders,
    useStudentGradeList,
} from "../../../../../query/hooks/QueryHooksPMCGradebook";
import SummaryStrip from "./SummaryStrip";
import GradebookTable from "./GradebookTable";
import {
    BulkProgressWrapper,
    ExportButton,
    ExportButtonGroup,
    filterDropdownButtonActiveStyle,
    filterDropdownButtonStyle,
    FilterToolbarRow,
    GradebookCardBlock,
    GradebookPaginationAmountText,
    GradebookPaginationControls,
    GradebookPaginationFooter,
    GradebookPaginationPageButton,
    GradebookPaginationPageText,
    GradebookPaginationRight,
    GradebookPaginationRowsPerPage,
    GradebookPaginationSelect,
    ResetButton,
    SearchBox,
    SearchFilterBar,
    SearchIcon,
    SearchInput,
    ModalOverlay,
    ModalContainer,
    ModalHeader,
    ModalTitle,
    CloseButton,
    ModalDescription,
    FieldGroup,
    FieldLabel,
    TogglesRow,
    ErrorMessage,
    ModalFooter,
    CancelButton,
    multiSelectStyles,
} from "./PMCGradeBook.styles";

const sortValueGetters = {
    student: (student) => student?.full_name || "",
    origin: (student) => student?.getOriginIntake || "",
    latest: (student) => student?.getLatestEnrolment || "",
};

const MultiValueRemove = (props) => (
    <components.MultiValueRemove {...props}>
        <i className="fal fa-times"></i>
    </components.MultiValueRemove>
);

function PMCGradeBook(props) {
    const location = useLocation();
    const query = new URLSearchParams(location.search);
    const queryVersionId = query.get("versionId");
    const queryProgrammeId = query.get("programmeId")
    const history = useHistory();
    const [debouncedTerm, setDebouncedTerm] = useState("");
    const search = useDebounce(debouncedTerm, 1000);
    const [percentageView, setPercentageView] = useState(false);
    const [tableState, setTableState] = useState({ page: 1, limit: 10 });
    const [saveGradesLoading, setSaveGradesLoading] = useState(false);
    const [updateValueArr, setUpdateValueArr] = useState([]);
    const [intake, setIntake] = useState({ arr: [], checkObj: {} });
    const [graduated, setGraduated] = useState({ arr: [], checkObj: {} });
    const [selectAllLoading, setSelectAllLoading] = useState(false);
    const [selectedIds, setSelectedIds] = useState([]);
    const [selectedStudentDetails, setSelectedStudentDetails] = useState({});
    const [sortConfig, setSortConfig] = useState({ key: null, direction: null });
    const [bulkProgress, setBulkProgress] = useState(null);
    const [bulkSuccessMessage, setBulkSuccessMessage] = useState(null);
    const [calculatingStudentId, setCalculatingStudentId] = useState(null);
    const tableScrollRef = useRef(null);
    const scrollbarProxyRef = useRef(null);
    const isSyncingScroll = useRef(false);
    const cancelBulkQueueRef = useRef(false);
    const exportCancelledRef = useRef(false);

    const [exportModalOpen, setExportModalOpen] = useState(false);
    const [exportIntakeOptions, setExportIntakeOptions] = useState([]);
    const [exportIntakeLoading, setExportIntakeLoading] = useState(false);
    const [exportSelectedIntakes, setExportSelectedIntakes] = useState([]);
    const [exportIncludeNonWeighted, setExportIncludeNonWeighted] = useState(false);
    const [exportIncludeRedo, setExportIncludeRedo] = useState(true);
    const [exportGenerating, setExportGenerating] = useState(false);
    const [exportError, setExportError] = useState(null);
    const [exportProgrammeCode, setExportProgrammeCode] = useState('');

    const { data: summaryTotals, isLoading: summaryTotalsLoading } = useProgrammeSummary(queryProgrammeId);
    const isVersionLocked = Number(props?.versionData?.lock_version_settings) === 1;
    const qcCoordinator = props?.versionData?.coordinator;

    usePermissionGuardRedirect(['cagbview']);

    const shouldBlockNavigation = updateValueArr.length;

    const handleNavigation = (location, page, states) => {
        if (shouldBlockNavigation) {
            if (Swal.isVisible()) {
                return false;
            }
            Swal.fire({
                title: "Warning",
                text: "You Have Unsaved Changes Left! Do you want to save changes",
                icon: "warning",
                showCancelButton: true,
                confirmButtonColor: "#3085d6",
                cancelButtonColor: "#d33",
                cancelButtonText: "No, Leave",
                confirmButtonText: "Yes, Save Changes",
            }).then((value) => {
                if (value.isConfirmed) {
                    Swal.fire({
                        title: "Please wait",
                        text: "Saving changes...",
                        allowOutsideClick: false,
                        onBeforeOpen: async () => {
                            Swal.showLoading();
                            const values = {
                                modulesArr: updateValueArr,
                                id: [Number(queryProgrammeId)],
                                versionId :queryVersionId
                            };
                            try {
                                await updatePmcScoreCancelToken(values);
                                setUpdateValueArr([]);
                                await Swal.fire({
                                    icon: "success",
                                    title: "Success",
                                    text: "Updated Successfully",
                                });
                                if (location) {
                                    history.push(location.pathname + (location.search || ""));
                                } else if (!location && page) {
                                    if (page == "exempted") {
                                        handleExemption(...states)
                                    } else {
                                        setTableState((prevState) => ({
                                            ...prevState,
                                            page:
                                                page === "firstPage"
                                                    ? 1
                                                    : page === "prevPage"
                                                        ? paginationState.currentPage - 1
                                                        : page === "nextPage"
                                                            ? +paginationState.currentPage + 1
                                                            : paginationState.lastPage,
                                        }));
                                    }
                                }
                            } catch (err) {
                                Swal.close(); // Close the "Saving changes..." popup if there was an error
                                Swal.fire({
                                    icon: "error",
                                    title: "Error",
                                    text: `${err?.response?.data?.data || "Something went wrong"}`,
                                });
                            }
                        },
                    });
                } else {
                    setUpdateValueArr([]);
                    if (location) {
                        history.push(location.pathname + (location.search || ""));
                    } else if (!location && page) {
                        if (page == "exempted") {
                            handleExemption(...states)
                        } else {
                            setTableState((prevState) => ({
                                ...prevState,
                                page:
                                    page === "firstPage"
                                        ? 1
                                        : page === "prevPage"
                                            ? paginationState.currentPage - 1
                                            : page === "nextPage"
                                                ? +paginationState.currentPage + 1
                                                : paginationState.lastPage,
                            }));
                        }
                    }
                }
            });

            return false; // Prevent the default navigation behavior
        } else if (page == "exempted") {
            handleExemption(...states)
        }
    };

    useEffect(() => {
        const handleBeforeUnload = (event) => {
            if (shouldBlockNavigation) {
                event.preventDefault();
            }
        };

        window.addEventListener("beforeunload", handleBeforeUnload);

        return () => {
            window.removeEventListener("beforeunload", handleBeforeUnload);
        };
    }, [shouldBlockNavigation]);

    const queryClient = useQueryClient();

    const moduleColumnHeadersQuery = useModuleColumnHeaders({
        programmeId: queryProgrammeId,
        versionId: queryVersionId,
    });
    const moduleHeader = moduleColumnHeadersQuery.data;

    const dropdownFiltersQuery = useIntakeAndGraduationDropdownFilters({
        programmeId: queryProgrammeId,
        versionId: queryVersionId,
    });
    const filterData = dropdownFiltersQuery.data;
    const studentArr = dropdownFiltersQuery.data.students;
    const totalStudents = dropdownFiltersQuery.data.totalStudents;

    const studentGradeListPayload = {
        id: queryProgrammeId,
        versionId: queryVersionId,
        key: sortConfig.key || "",
        sort: sortConfig.direction ? sortConfig.direction.toUpperCase() : "DESC",
        exportStatus: "false",
        search: search,
        page: tableState.page,
        limit: tableState.limit,
        intake_year_number: intake.arr || [],
        graduation: graduated.arr || [],
        students: studentArr || [],
    };
    const studentGradeListQuery = useStudentGradeList(studentGradeListPayload);
    const userData = studentGradeListQuery.data.data;
    const qualifications = studentGradeListQuery.data.qualifications;
    const paginationState = studentGradeListQuery.data.pagination;

    const loading = {
        heading: moduleColumnHeadersQuery.isLoading,
        list: studentGradeListQuery.isFetching,
        listInitial: studentGradeListQuery.isLoading,
    };

    const setUserData = (updatedUserData) => {
        queryClient.setQueryData(studentGradeListQueryKey(studentGradeListPayload), (prev) => ({
            ...(prev ?? studentGradeListQuery.data),
            data: updatedUserData,
        }));
    };

    const sortedUserData = useMemo(() => {
        if (!sortConfig.key || !userData?.length) {
            return userData;
        }
        const getValue = sortValueGetters[sortConfig.key];
        const sorted = [...userData].sort((studentA, studentB) => {
            const valueA = getValue(studentA).toString().toLowerCase();
            const valueB = getValue(studentB).toString().toLowerCase();
            if (valueA < valueB) {
                return sortConfig.direction === "asc" ? -1 : 1;
            }
            if (valueA > valueB) {
                return sortConfig.direction === "asc" ? 1 : -1;
            }
            return 0;
        });
        return sorted;
    }, [userData, sortConfig]);

    const handleSort = (key) => {
        setSortConfig((prevState) => ({
            key,
            direction: prevState.key === key && prevState.direction === "asc" ? "desc" : "asc",
        }));
        setTableState((prevState) => ({ ...prevState, page: 1 }));
    };

    useEffect(() => {
        const mainEl = tableScrollRef.current;
        const proxyEl = scrollbarProxyRef.current;
        if (!mainEl || !proxyEl) {
            return;
        }

        const syncFromMain = () => {
            if (isSyncingScroll.current) {
                return;
            }
            isSyncingScroll.current = true;
            const mainMax = mainEl.scrollWidth - mainEl.clientWidth;
            const proxyMax = proxyEl.scrollWidth - proxyEl.clientWidth;
            proxyEl.scrollLeft = mainMax > 0 ? (mainEl.scrollLeft / mainMax) * proxyMax : 0;
            isSyncingScroll.current = false;
        };
        const syncFromProxy = () => {
            if (isSyncingScroll.current) {
                return;
            }
            isSyncingScroll.current = true;
            const mainMax = mainEl.scrollWidth - mainEl.clientWidth;
            const proxyMax = proxyEl.scrollWidth - proxyEl.clientWidth;
            mainEl.scrollLeft = proxyMax > 0 ? (proxyEl.scrollLeft / proxyMax) * mainMax : 0;
            isSyncingScroll.current = false;
        };

        mainEl.addEventListener("scroll", syncFromMain);
        proxyEl.addEventListener("scroll", syncFromProxy);
        return () => {
            mainEl.removeEventListener("scroll", syncFromMain);
            proxyEl.removeEventListener("scroll", syncFromProxy);
        };
    }, [sortedUserData, moduleHeader, loading.list, loading.heading]);

    const toggleSelectRow = (student) => {
        setSelectedIds((prevState) =>
            prevState.includes(student.id)
                ? prevState.filter((id) => id !== student.id)
                : [...prevState, student.id]
        );
        setSelectedStudentDetails((prevState) => {
            if (prevState[student.id]) {
                const updated = { ...prevState };
                delete updated[student.id];
                return updated;
            }
            return { ...prevState, [student.id]: student };
        });
    };

    const toggleSelectAll = async () => {
        const totalFilteredCount = paginationState.total || 0;
        const allSelected = totalFilteredCount > 0 && selectedIds.length === totalFilteredCount;

        if (allSelected) {
            setSelectedIds([]);
            setSelectedStudentDetails({});
            return;
        }

        setSelectedIds(userData.map((student) => student.id));
        setSelectedStudentDetails(
            userData.reduce((acc, student) => {
                acc[student.id] = student;
                return acc;
            }, {})
        );

        setSelectAllLoading(true);
        try {
            const students = await fetchAllFilteredStudents();
            setSelectedIds(students.map((student) => student.id));
            setSelectedStudentDetails(
                students.reduce((acc, student) => {
                    acc[student.id] = student;
                    return acc;
                }, {})
            );
        } finally {
            setSelectAllLoading(false);
        }
    };

    useEffect(() => {
        setSelectedIds([]);
        setSelectedStudentDetails({});
    }, [search, intake.arr, graduated.arr]);

    useEffect(() => {
        if (!bulkSuccessMessage) {
            return;
        }
        const timeoutId = setTimeout(() => setBulkSuccessMessage(null), 5000);
        return () => clearTimeout(timeoutId);
    }, [bulkSuccessMessage]);

    const handleSearchFilter = (event) => {
        const value = event.target.value;
        setDebouncedTerm(value);
    };

    const resetFilter = () => {
        setDebouncedTerm("");
        setIntake({ arr: [], checkObj: {} });
        setGraduated({ arr: [], checkObj: {} });
        setSortConfig({ key: null, direction: null });
        setTableState((prevState) => ({ ...prevState, page: 1 }));
    };

    const handleExemption = (moduleId, studentId, isExempted, row) => {
        const updatedUserData = userData.map(student => {
            if (student.id === studentId) {
                return {
                    ...student,
                    modules: student.modules.map(module => {
                        if (module.ModuleId === moduleId) {
                            return {
                                ...module,
                                courseGradeDetails: {
                                    ...module.courseGradeDetails,
                                    grant_exemption: isExempted ? 1 : 0,
                                },
                            };
                        }
                        return module;
                    }),
                };
            }
            return student;
        });
        setUserData(updatedUserData);

        setUpdateValueArr(prev => {
            const updated = [...prev];
            const index = updated.findIndex(
                pendingChange => pendingChange.student_id === studentId && pendingChange.module_id === moduleId
            );

            if (index > -1) {
                updated[index] = {
                    ...updated[index],
                    grant_exemption: isExempted ? 1 : 0,
                };
            } else {
                updated.push({
                    student_id: studentId,
                    module_id: moduleId,
                    grant_exemption: isExempted ? 1 : 0,
                    pmc_id: queryProgrammeId,
                    qid: row?.qualification,
                    intake_id: row?.courseGradeDetails?.intake_id || ""
                });
            }
            const updatedGradeData = updated.map(change => ({ ...change, version_id: queryVersionId }));
            return updatedGradeData;
        });
    };

    const openExportModal = async () => {
        setExportModalOpen(true);
        setExportError(null);
        setExportSelectedIntakes([]);
        setExportIncludeNonWeighted(false);
        setExportIncludeRedo(true);
        setExportIntakeOptions([]);
        setExportIntakeLoading(true);
        setExportProgrammeCode('');

        try {
            const originIntakesResponse = await getGradebookOriginIntakes({ id: queryProgrammeId, versionId: queryVersionId });
            const programmeCodeResponse = await getGradebookProgrammeCode({ id: queryProgrammeId, versionId: queryVersionId });

            const availableIntakes = (originIntakesResponse?.data?.data || []).filter((intake) => Number(intake.studentCount) > 0);
            setExportIntakeOptions(availableIntakes);
            setExportProgrammeCode(programmeCodeResponse?.data?.data?.code || '');
        } catch (error) {
            setExportError('Unable to load the available origin intakes. Please try again.');
        } finally {
            setExportIntakeLoading(false);
        }
    };

    const closeExportModal = () => {
        if (exportGenerating) {
            exportCancelledRef.current = true;
            setExportGenerating(false);
        }

        setExportModalOpen(false);
    };

    const handleGenerateExport = async () => {
        if (!exportSelectedIntakes.length || exportGenerating) {
            return;
        }

        exportCancelledRef.current = false;
        setExportGenerating(true);
        setExportError(null);

        try {
            const response = await exportGradebookExcel({
                id: queryProgrammeId,
                versionId: queryVersionId,
                originIntakes: exportSelectedIntakes.map((intake) => intake.value),
                includeNonWeighted: exportIncludeNonWeighted,
                includeRedo: exportIncludeRedo,
            });

            if (exportCancelledRef.current) {
                return;
            }

            const blob = new Blob([response.data], {
                type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
            });

            const url = window.URL.createObjectURL(blob);
            const link = document.createElement('a');

            const fileName = exportProgrammeCode
                ? `${exportProgrammeCode}_Gradebook_${moment().format('YYYYMMDD')}.xlsx`
                : 'Gradebook.xlsx';

            link.href = url;
            link.setAttribute('download', fileName);

            document.body.appendChild(link);
            link.click();
            link.remove();

            window.URL.revokeObjectURL(url);

            setExportGenerating(false);
            setExportModalOpen(false);
        } catch (error) {
            if (exportCancelledRef.current) {
                return;
            }

            setExportGenerating(false);
            setExportError(error?.response?.data?.message || 'Something went wrong generating the export. Please try again.');
        }
    };

    const exportData = async (fileType, fileName) => {
        const Values = {
            id: queryProgrammeId,
            versionId: queryVersionId,
            key: "",
            sort: "DESC",
            exportStatus: "false",
            search: search,
            page: tableState.page,
            limit: tableState.limit,
            intake_year_number: intake.arr || [],
            graduation: graduated.arr || [],
            students: studentArr || [],
        };

        try {
            const gradeListResponse = await getProgrammeModulesGradeStudentList(Values);
            const respData = gradeListResponse?.data?.data;
            const header = [
                "Student Name",
                "Student Number",
                "Original Qualification",
                "Latest Intake",
                "Module Name",
                "Module Grade",
                "Module Result",
                "Module Intake",
                "Programme Grade",
                "Programme Result",
            ];
            const exportRows = [];

            respData.forEach((student) => {
                const dataItem = {
                    "Student Name": `${student.full_name}`,
                    "Student Number": student?.student_num || student?.student_crm_id,
                    "Original Qualification": student.getOriginIntake?.split("-").slice(0, 2).join("-") || "N/A",
                    "Latest Intake": student?.getLatestEnrolment?.split("-").slice(0, 2).join("-") || "N/A",
                    "Module Name": "",
                    "Module Grade": "",
                    "Module Result": "",
                    "Module Intake": "",
                    "Programme Grade": (student?.programCalculate
                        ? (() => {
                            const calc = student.programCalculate;
                            if (calc?.pass_status === "N/A") {
                                return "Pending Calculation";
                            }
                            if (calc?.pass_status === "N/A" && (calc?.scoreRecieved !== "N/A" || !calc?.gradeText)) {
                                return "N/A";
                            }
                            return percentageView
                                ? ((calc.scoreRecieved !== undefined && calc.scoreRecieved !== "N/A") || calc.scoreRecieved === 0)
                                    ? typeof calc.scoreRecieved === "number"
                                        ? calc.scoreRecieved % 1 === 0 ? `${calc.scoreRecieved}%` : `${calc.scoreRecieved.toFixed(2)}%`
                                        : typeof calc.scoreRecieved === "string"
                                            ? calc.scoreRecieved.includes("%")
                                                ? parseFloat(calc.scoreRecieved % 1 === 0 ? `${calc.scoreRecieved}%` : `${calc.scoreRecieved.toFixed(2)}%`)
                                                : parseFloat(calc.scoreRecieved % 1 === 0 ? `${calc.scoreRecieved}%` : `${calc.scoreRecieved.toFixed(2)}%`)
                                            : "N/A"
                                    : "N/A"
                                : calc.grading_type !== 3
                                    ? typeof calc.gradeText === "string" && calc.gradeText.includes("%")
                                        ? (parseFloat(calc.gradeText) % 1 === 0 ? parseFloat(calc.gradeText) : parseFloat(calc.gradeText).toFixed(2)) + "%"
                                        : typeof calc.gradeText === "number"
                                            ? (calc.gradeText % 1 === 0 ? calc.gradeText : calc.gradeText.toFixed(2)) + "%"
                                            : calc.gradeText || "N/A"
                                    : `${calc.programeAssMark} / ${calc.programeAssTotalMark}`;
                        })()
                        : "N/A"),
                    "Programme Result": student?.programCalculate?.pass_status === "N/A"
                        ? "Pending Calculation"
                        : RenderQuizAttemptResultStatus(student?.programCalculate?.pass_status)?.text || "N/A",
                };
                exportRows.push(dataItem);

                student.modules &&
                    student.modules.forEach((moduleItem, index) => {
                        const gradeText1 = moduleItem?.courseGradeDetails?.scoreRecieved;
                        const gradeText2 = moduleItem?.courseGradeDetails?.gradeText;
                        const statusAvailable = moduleItem?.courseGradeDetails?.pass_status && moduleItem?.courseGradeDetails?.pass_status !== "N/A";
                        const gradeAvailable = ((gradeText1 && gradeText1 !== "N/A") || (gradeText2 && gradeText2 !== "N/A"));

                        let moduleGrade = "N/A";

                        if (moduleItem?.grant_exemption) {
                            moduleGrade = "Exempted";
                        } else if (!moduleItem?.courseGradeDetails || moduleItem.courseGradeDetails.length === 0) {
                            moduleGrade = "Not Enrolled";
                        } else if (!statusAvailable) {
                            moduleGrade = "Pending Calculation";
                        } else if (statusAvailable && (gradeText1 && gradeText1 !== "N/A")) {
                            moduleGrade = `${Math.round(parseFloat(gradeText1))}%`;
                        } else if (statusAvailable && (gradeText2 && gradeText2 !== "N/A")) {
                            moduleGrade = gradeText2;
                        } else {
                            moduleGrade = "N/A";
                        }

                        let moduleResult = "N/A";
                        if (moduleItem?.grant_exemption) {
                            moduleResult = "Exempted";
                        } else if (!moduleItem?.courseGradeDetails || moduleItem.courseGradeDetails.length === 0) {
                            moduleResult = "Not Enrolled";
                        } else if (!statusAvailable) {
                            moduleResult = "Pending Calculation";
                        } else if (statusAvailable && gradeAvailable) {
                            moduleResult = RenderQuizAttemptResultStatus(moduleItem?.courseGradeDetails?.pass_status)?.text || "N/A";
                        } else {
                            moduleResult = "N/A";
                        }

                        let moduleIntake = "N/A";
                        if (moduleItem?.grant_exemption) {
                            moduleIntake = "Exempted";
                        } else if (!moduleItem?.courseGradeDetails || moduleItem.courseGradeDetails.length === 0) {
                            moduleIntake = "Not Enrolled";
                        } else if (!statusAvailable) {
                            moduleIntake = "Pending Calculation";
                        } else if ((statusAvailable && gradeAvailable) && moduleItem?.courseGradeDetails?.intakes_number_year) {
                            moduleIntake = moduleItem.courseGradeDetails.intakes_number_year;
                        } else {
                            moduleIntake = "N/A";
                        }

                        const subDataItem = {
                            "Student Name": "",
                            "Student Number": "",
                            "Module Name": moduleHeader[index]?.Portal || "",
                            "Module Grade": moduleGrade,
                            "Module Result": moduleResult,
                            "Module Intake": moduleIntake,
                        };
                        exportRows.push(subDataItem);
                    });
            });

            if (fileType === "csv") {
                const csvString = Papa.unparse({ fields: header, data: exportRows });
                const blob = new Blob([csvString], {
                    type: "text/csv;charset=utf-8,",
                });

                const blobURL = window.URL.createObjectURL(blob);
                const anchor = document.createElement("a");
                anchor.download = fileName;
                anchor.href = blobURL;
                anchor.dataset.downloadurl = ["text/csv", anchor.download, anchor.href].join(":");
                anchor.click();

                setTimeout(() => {
                    URL.revokeObjectURL(blobURL);
                }, 1000);
                Swal.close();
            } else if (fileType === "xlsx") {
                const compatibleData = exportRows.map((row) => {
                    const obj = {};
                    header.forEach((col) => {
                        obj[col] = row[col];
                    });
                    return obj;
                });

                const wb = XLSX.utils.book_new();
                const ws1 = XLSX.utils.json_to_sheet(compatibleData, { header });
                XLSX.utils.book_append_sheet(wb, ws1, "React Table Data");
                XLSX.writeFile(wb, `${fileName}.xlsx`);
                Swal.close();
                return false;
            }

            if (fileType === "pdf") {
                const compatibleData = exportRows.map((row) => {
                    return [
                        row["Student Name"],
                        row["Student Number"],
                        row["Original Qualification"],
                        row["Latest Intake"],
                        row["Module Name"],
                        row["Module Grade"],
                        row["Module Result"],
                        row["Module Intake"],
                        row["Programme Grade"],
                        row["Programme Result"],
                    ];
                });
                const doc = new JsPDF();
                doc.autoTable({
                    head: [header],
                    body: compatibleData,
                    styles: {
                        minCellHeight: 10,
                        minCellWidth: 5,
                        halign: "left",
                        fontSize: 8,
                    },
                });
                doc.save(`${fileName}.pdf`);
                Swal.close();
                return false;
            }
        } catch (err) {
            console.error(err);
        }
    };

    const exportXlsxData = async (fileName, courseName) => {
        try {
            const Values = {
                id: queryProgrammeId,
                versionId: queryVersionId,
                key: "",
                sort: "DESC",
                exportStatus: "false",
                search: search,
                page: tableState.page,
                limit: tableState.limit,
                intake_year_number: intake.arr || [],
                graduation: graduated.arr || [],
                students: studentArr || [],
            };

            const gradeListResponse = await getProgrammeModulesGradeStudentList(Values);

            if (gradeListResponse?.status == 200) {
                const respData = gradeListResponse?.data?.data || [];
                const header = [
                    "Name",
                    "Surname",
                    "ID Number",
                    "Student Number",
                    "Original Qualification",
                    "Latest Intake",
                    ...moduleHeader.map((module) => module?.Portal),
                    "Programme Grade",
                    "Programme Result"
                ];

                const exportRows = respData?.flatMap((student) => {
                    const moduleValues = moduleHeader.map((module) => {
                        const moduleData = student.modules.find(
                            (row) => row.ModuleId === module?.ModuleId
                        );

                        if (!moduleData) {
                            return "N/A";
                        }

                        if (moduleData.grant_exemption) {
                            return "Exempted";
                        }
                        if ((!moduleData?.courseGradeDetails || moduleData.courseGradeDetails.length === 0)) {
                            return "Not Enrolled";
                        }

                        const gradeText1 = moduleData?.courseGradeDetails?.scoreRecieved;
                        const gradeText2 = moduleData?.courseGradeDetails?.gradeText;
                        const pStatus = moduleData?.courseGradeDetails?.pass_status;

                        if (!pStatus || pStatus === "N/A") {
                            return "Pending Calculation";
                        }

                        if ((gradeText1 == undefined || gradeText1 == "N/A") && (gradeText2 == undefined || gradeText2 == "N/A")) {
                            return "N/A";
                        }

                        const score = (moduleData?.courseGradeDetails?.scoreRecieved !== "N/A" && moduleData?.courseGradeDetails?.scoreRecieved !== undefined)
                            ? `${Math.round(parseFloat(moduleData.courseGradeDetails.scoreRecieved))}%`
                            : moduleData?.courseGradeDetails?.gradeText ?? "N/A";

                        const passStatus = moduleData?.courseGradeDetails?.pass_status
                            ? RenderQuizAttemptResultStatus(moduleData?.courseGradeDetails?.pass_status)?.text
                            : "N/A";

                        const moduleIntakeLabel = moduleData?.courseGradeDetails?.intakes_number_year || "N/A";

                        return `${moduleIntakeLabel}, ${score}, ${passStatus}`;
                    });

                    const rowData = [
                        student.first_name,
                        student.last_name,
                        student?.number || "Not Enrolled",
                        student?.student_crm_id || student?.student_num || "-",
                        student?.getOriginIntake?.split("-").slice(0, 2).join("-") || "-",
                        student?.getLatestEnrolment?.split("-").slice(0, 2).join("-") || "-",
                        ...moduleValues,
                        (student?.programCalculate
                            ? (() => {
                                const calc = student.programCalculate;
                                if (calc?.pass_status === "N/A") {
                                    return "Pending Calculation";
                                }
                                if (calc?.pass_status === "N/A" && (calc?.scoreRecieved !== "N/A" || !calc?.gradeText)) {
                                    return "N/A";
                                }
                                return percentageView
                                    ? ((calc.scoreRecieved !== undefined && calc.scoreRecieved !== "N/A") || calc.scoreRecieved === 0)
                                        ? typeof calc.scoreRecieved === "number"
                                            ? calc.scoreRecieved % 1 === 0 ? `${calc.scoreRecieved}%` : `${calc.scoreRecieved.toFixed(2)}%`
                                            : typeof calc.scoreRecieved === "string"
                                                ? calc.scoreRecieved.includes("%")
                                                    ? parseFloat(calc.scoreRecieved % 1 === 0 ? `${calc.scoreRecieved}%` : `${calc.scoreRecieved.toFixed(2)}%`)
                                                    : parseFloat(calc.scoreRecieved % 1 === 0 ? `${calc.scoreRecieved}%` : `${calc.scoreRecieved.toFixed(2)}%`)
                                                : "N/A"
                                        : "N/A"
                                    : calc.grading_type !== 3
                                        ? typeof calc.gradeText === "string" && calc.gradeText.includes("%")
                                            ? (parseFloat(calc.gradeText) % 1 === 0 ? parseFloat(calc.gradeText) : parseFloat(calc.gradeText).toFixed(2)) + "%"
                                            : typeof calc.gradeText === "number"
                                                ? (calc.gradeText % 1 === 0 ? calc.gradeText : calc.gradeText.toFixed(2)) + "%"
                                                : calc.gradeText || "N/A"
                                        : `${calc.programeAssMark} / ${calc.programeAssTotalMark}`;
                            })()
                            : "N/A"),
                        student?.programCalculate?.pass_status === "N/A"
                            ? "Pending Calculation"
                            : RenderQuizAttemptResultStatus(student?.programCalculate?.pass_status)?.text || "N/A",
                    ];

                    return [rowData];
                });

                const wb = new ExcelJS.Workbook();
                const ws = wb.addWorksheet('Excel Data');

                ws.views = [
                    {
                        state: 'frozen',
                        ySplit: 1,
                        xSplit: 1
                    },
                ];
                ws.properties.showGridLines = true;

                const columnStyles = [];
                header.forEach((col) => {
                    const style = {};
                    if (['Name', 'Surname', 'ID Number', 'Student Number', 'Original Qualification', 'Latest Intake'].includes(col)) {
                        style.font = { bold: true };
                        style.fill = {
                            type: 'pattern',
                            pattern: 'solid',
                            fgColor: { argb: 'FFDBDBDB' }, // Light gray background color
                        };
                        style.border = {
                            top: { style: 'thin', color: { argb: 'FF000000' } },
                            bottom: { style: 'thin', color: { argb: 'FF000000' } },
                            left: { style: 'thin', color: { argb: 'FF000000' } },
                            right: { style: 'thin', color: { argb: 'FF000000' } }
                        };
                    } else if (col === 'Final Mark') {
                        style.font = { color: { argb: "FFFFFF" } };
                        style.fill = {
                            type: 'pattern',
                            pattern: 'solid',
                            fgColor: { argb: 'FF7030A0' }, // Purple background color
                        };
                        style.border = {
                            top: { style: 'thin', color: { argb: 'FF000000' } },    // Black top border
                            bottom: { style: 'thin', color: { argb: 'FF000000' } }, // Black bottom border
                            left: { style: 'thin', color: { argb: 'FF000000' } },   // Black left border
                            right: { style: 'thin', color: { argb: 'FF000000' } }   // Black right border
                        };
                    } else {
                        style.fill = {
                            type: 'pattern',
                            pattern: 'solid',
                            fgColor: { argb: 'FFDBDBDB' }, // Light gray background color
                        };
                        style.border = {
                            top: { style: 'thin', color: { argb: 'FF000000' } },
                            bottom: { style: 'thin', color: { argb: 'FF000000' } },
                            left: { style: 'thin', color: { argb: 'FF000000' } },
                            right: { style: 'thin', color: { argb: 'FF000000' } }
                        };
                    }
                    columnStyles.push(style);
                });
                const staticRow = ws.addRow([courseName, '', '', '', '']);
                staticRow.height = 16;
                staticRow.getCell(1).fill = { type: 'pattern', pattern: 'solid', fgColor: { argb: 'FF66CCFF' } };
                staticRow.getCell(1).font = { bold: true };
                staticRow.getCell(1).alignment = { horizontal: 'center', vertical: "bottom" };
                staticRow.getCell(1).border = {};
                staticRow.getCell(5).fill = { type: 'pattern', pattern: 'solid', fgColor: { argb: 'FF203764' } };
                ws.mergeCells(`A${staticRow.number}:D${staticRow.number}`);

                const headerRow = ws.addRow(header);
                headerRow.eachCell((cell, colNumber) => {
                    if (columnStyles[colNumber - 1].font) {
                        cell.font = columnStyles[colNumber - 1].font;
                    }
                    cell.fill = columnStyles[colNumber - 1].fill;
                    cell.border = columnStyles[colNumber - 1].border;
                });

                exportRows.forEach((row) => {
                    const dataRow = ws.addRow(row);
                    dataRow.eachCell((cell, colNumber) => {
                        cell.border = columnStyles[colNumber - 1].border;
                    });
                });

                const buffer = await wb.xlsx.writeBuffer();
                const blob = new Blob([buffer], { type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet' });
                const url = URL.createObjectURL(blob);

                const a = document.createElement('a');
                a.href = url;
                a.download = `${fileName}.xlsx`;
                a.click();
            }

            Swal.close();
        } catch (err) {
            console.error(err);
            Swal.close();
            Swal.fire("Error", "Failed to export data", "error");
        }
    };

    const handleSaveGrades = async (studentID) => {
        Swal.fire({
            title: "Updating",
            onOpen: function () {
                Swal.showLoading();
            },
        });
        setSaveGradesLoading(true);
        const values = {
            intake_id: queryProgrammeId,
            courses: updateValueArr,
            student_id: studentID,
        };
        if (!studentID) {
            delete values.student_id;
        }
        try {
            await updateCousesScore(values);
            setSaveGradesLoading(false);
            if (studentID) {
                const filteredArr = updateValueArr.filter(
                    (change) => change.student_id !== studentID
                );
                setUpdateValueArr(filteredArr);
            } else {
                setUpdateValueArr([]);
            }
            Swal.close();
            await Swal.fire({
                icon: "success",
                title: "Success",
                text: "Updated Successfully",
            });
            studentGradeListQuery.refetch();
        } catch (err) {
            setSaveGradesLoading(false);
            Swal.close();
            Swal.fire({
                icon: "error",
                title: "Error",
                text: `${err?.response?.data?.data}`,
            });
        }
    };

    const runBulkQueue = async (queuedItems, actionLabel, processItem) => {
        cancelBulkQueueRef.current = false;
        setSaveGradesLoading(true);
        setBulkSuccessMessage(null);
        setBulkProgress({ total: queuedItems.length, completed: 0, actionLabel, cancelRequested: false });

        const failedItems = [];

        for (const queuedItem of queuedItems) {
            if (cancelBulkQueueRef.current) {
                break;
            }

            try {
                await processItem(queuedItem);
            } catch (error) {
                failedItems.push(queuedItem);
            }

            setBulkProgress((prevState) => (prevState ? { ...prevState, completed: prevState.completed + 1 } : prevState));
        }

        const wasCancelled = cancelBulkQueueRef.current;
        setBulkProgress(null);
        setSaveGradesLoading(false);
        return { wasCancelled, failedItems };
    };

    const handleCancelBulkProgress = () => {
        cancelBulkQueueRef.current = true;
        setBulkProgress((prevState) => (prevState ? { ...prevState, cancelRequested: true } : prevState));
    };

    const calculateStudentGrade = async (studentId) => {
        const values = {
            id: [Number(queryProgrammeId)],
            versionId: queryVersionId,
            student_id: studentId,
        };
        const studentModules = updateValueArr.filter((change) => change.student_id == studentId);
        if (studentModules.length) {
            values.modulesArr = studentModules;
        }
        await updatePmcScoreCancelToken(values);
    };

    const handleGradeCalculationForIds = async (calculatedIds, { singleStudentId } = {}) => {
        const count = calculatedIds.length;
        const confirmation = await Swal.fire({
            title: "Are You Sure?",
            text: `Calculate final grades for ${count} selected student${count === 1 ? "" : "s"}?`,
            icon: "warning",
            showCancelButton: true,
            confirmButtonText: "Yes, Calculate",
            cancelButtonText: "Cancel",
            cancelButtonColor: tokens.colors.states.alert.default,
        });

        if (!confirmation.isConfirmed) {
            return;
        }

        if (singleStudentId) {
            setCalculatingStudentId(singleStudentId);
        }

        const { wasCancelled, failedItems } = await runBulkQueue(calculatedIds, "Calculating grades", calculateStudentGrade);

        if (singleStudentId) {
            setCalculatingStudentId(null);
        }

        setUpdateValueArr((prevState) => prevState.filter((change) => !calculatedIds.includes(change.student_id)));

        if (!wasCancelled && !failedItems.length) {
            setBulkSuccessMessage("Grades Calculated Successfully");
            studentGradeListQuery.refetch();
            return;
        }

        Swal.fire({
            icon: wasCancelled ? "info" : "warning",
            title: wasCancelled ? "Cancelled" : "Partially Completed",
            text: wasCancelled
                ? "Remaining students were not calculated"
                : `${failedItems.length} of ${calculatedIds.length} student${calculatedIds.length === 1 ? "" : "s"} failed to calculate`,
        }).then(() => studentGradeListQuery.refetch());
    };

    const handleBulkGradeCalculation = () => handleGradeCalculationForIds([...selectedIds]);

    const handleSingleGradeCalculation = (studentId) =>
        handleGradeCalculationForIds([studentId], { singleStudentId: studentId });

    const handleDownloadSOR = async (student, { silent = false } = {}) => {
        const programmeId = student?.qualification_redirection_id;
        if (!programmeId) {
            if (!silent) {
                Swal.fire({
                    icon: "error",
                    title: "Error",
                    text: "No linked qualification found for this student.",
                });
            }
            return;
        }

        const swalPro = Swal.mixin({
            title: "Downloading PDF",
            text: "Please wait...",
            icon: "info",
            allowOutsideClick: false,
            timerProgressBar: true,
            onBeforeOpen: () => {
                Swal.showLoading();
            },
        });
        if (!silent) {
            swalPro.fire();
        }

        try {
            const [gradebookRes, assignedRes, brandRes] = await Promise.all([
                getStudentGradebookCancelToken(student.id),
                GetAssignedSubjectCancelToken(student.id),
                getStudentBrand({ id: [student.id] }),
            ]);

            const details = gradebookRes?.data?.data || [];
            const course = details.find((courseItem) => courseItem?.id === programmeId);

            if (!course) {
                if (!silent) {
                    swalPro.close();
                    Swal.fire({
                        icon: "error",
                        title: "Error",
                        text: "Statement of Results data not found for this student.",
                    });
                }
                return;
            }

            const exemptionByIntakeId = {};
            if (assignedRes?.status === 200 && Array.isArray(assignedRes.data?.assign_subject)) {
                assignedRes.data.assign_subject.forEach((qual) => {
                    (qual.sub_item || []).forEach((subject) => {
                        if (subject.intake_id != null) {
                            exemptionByIntakeId[subject.intake_id] = Number(subject.grant_exemption) === 1 ? 1 : 0;
                        }
                    });
                });
            }

            const isNotEnrolled = (intake) => intake?.ModuleId && !intake?.intake;
            const isGraduated = student?.GraduationConditionMetDate != null;

            const coursesAlongAssessment = Array.isArray(course?.courseWithAssessment) && course.courseWithAssessment.length > 0
                ? course.courseWithAssessment
                    .filter((intake) => !isNotEnrolled(intake))
                    .map((intake) => {
                        const intakeId = intake?.intake_id ?? intake?.id;
                        const intakeExempted = exemptionByIntakeId[intakeId] !== undefined
                            ? exemptionByIntakeId[intakeId] === 1
                            : Number(intake?.grant_exemption) === 1;
                        return {
                            course_name: course?.grading_standard == 2
                                ? intake?.name
                                : intake?.course_name || "N/A",
                            weight: intakeExempted
                                ? "Exempted"
                                : (!Array.isArray(intake?.assessments) || intake.assessments.length === 0)
                                    ? "N/A"
                                    : intake?.weight ?? "N/A",
                            grade: intakeExempted
                                ? "Exempted"
                                : (!Array.isArray(intake?.assessments) || intake.assessments.length === 0)
                                    ? "N/A"
                                    : intake?.grading_type == 0
                                        ? Math.round(intake?.scoreRecieved || 0) + "%"
                                        : intake?.grading_type == 3 && course?.grading_standard == 2
                                            ? `${intake?.allAss_ass_mark ?? 0}/${intake?.allAss_total_mark ?? 0}`
                                            : intake?.grading_type == 3 && course?.grading_standard != 2
                                                ? `${intake?.getAssessmentCalculate_sum_ass_mark ?? 0}/${intake?.getAssessmentCalculate_sum_ass_total_mark ?? 0}`
                                                : intake?.gradeText || "N/A",
                            result: intakeExempted
                                ? "Exempted"
                                : (!Array.isArray(intake?.assessments) || intake.assessments.length === 0)
                                    ? "N/A"
                                    : intake?.pass_status
                                        ? intake?.pass_status
                                        : "N/A",
                            assessments: Array.isArray(intake?.assessments) && intake.assessments.length > 0
                                ? intake.assessments.map((assessment) => ({
                                    name: course?.grading_standard == 2
                                        ? assessment?.assessment_name
                                        : assessment?.name || "N/A",
                                    weight: (Number(assessment?.grant_exemption) === 1 || intakeExempted)
                                        ? "Exempted"
                                        : assessment?.ass_weighting ?? "N/A",
                                    result: (Number(assessment?.grant_exemption) === 1 || intakeExempted)
                                        ? "Exempted"
                                        : (assessment?.submited == "0" || moment.unix(assessment?.close_date_time) > moment())
                                            ? "N/A"
                                            : (assessment?.pass_status && assessment.pass_status !== "N/A")
                                                ? assessment.pass_status
                                                : "N/A",
                                    grade: (Number(assessment?.grant_exemption) === 1 || intakeExempted)
                                        ? "Exempted"
                                        : (assessment?.submited == "0" || moment.unix(assessment?.close_date_time) > moment())
                                            ? "N/A"
                                            : assessment?.grading_type == 3
                                                ? `${assessment?.ass_mark ?? 0}/${assessment?.ass_total_mark ?? 0}`
                                                : assessment?.gradeText || "N/A",
                                    isExclude: !!assessment?.isExclude,
                                    isAssignedSickStudent: !!assessment?.isAssignedSickStudent,
                                    isSickForThisStudent: !!assessment?.isSickForThisStudent,
                                    isSupplementaryForThisStudent: !!assessment?.isSupplementaryForThisStudent,
                                }))
                                : [],
                            final_status: isGraduated ? "Graduated" : "Not graduated",
                            final_grade: course.programCalculate?.grading_type == 0
                                ? Math.round(course.programCalculate?.scoreRecieved) + "%"
                                : course.programCalculate?.grading_type == 3
                                    ? `${course.programCalculate?.programeAssMark}/${course.programCalculate?.programeAssTotalMark}`
                                    : course.programCalculate?.gradeText,
                        };
                    })
                    .filter((courseItem) => !courseItem?.course_name?.trim()?.toLowerCase()?.includes("orientation"))
                : [];

            const state = localStorage.getItem("state");
            const brandVisuals = state ? JSON.parse(state)?.brandVisuals?.config : undefined;

            const blob = await pdf(
                <LetterHeadPDF3
                    detailData={coursesAlongAssessment}
                    studentAndCourseDetails={{
                        program_name: course?.program_name,
                        Student_name: student.full_name,
                        ID_number: student?.number,
                        Student_number: student?.student_crm_id || student?.student_num,
                        start: course?.start
                            ? course.start?.toString()?.length == 10
                                ? moment.unix(course?.start).format("DD MMMM YYYY")
                                : moment(course?.start).format("DD MMMM YYYY")
                            : "",
                        end: course?.end
                            ? course.end?.toString()?.length == 10
                                ? moment.unix(course?.end).format("DD MMMM YYYY")
                                : moment(course?.end).format("DD MMMM YYYY")
                            : "",
                        intake: course?.number && course?.year ? `${course?.number}-${course?.year}` : "",
                        learning_method: course?.type ? RenderLearningMethodGradebook(course?.type).text : "",
                    }}
                    brandData={brandRes?.data?.getBrandDetail}
                />
            ).toBlob();

            const blobURL = window.URL.createObjectURL(blob);
            const anchor = document.createElement("a");
            anchor.href = blobURL;
            anchor.download = `${student?.student_crm_id || student?.student_num}_${student.full_name}_${course?.program_name}_SOR_${brandVisuals?.brand_name || ""}_${moment(new Date()).format("DD MM YY")}.pdf`;
            anchor.click();
            URL.revokeObjectURL(blobURL);

            if (!silent) {
                swalPro.close();
                Swal.fire({
                    icon: "success",
                    title: "Success",
                    text: "Download Successful",
                });
            }
        } catch (err) {
            if (!silent) {
                swalPro.close();
                Swal.fire({
                    icon: "error",
                    title: "Error",
                    text: "Something went wrong!",
                });
            } else {
                throw err;
            }
        }
    };

    const handleBulkDownloadSOR = async () => {
        const count = selectedIds.length;
        const confirmation = await Swal.fire({
            title: "Are You Sure?",
            text: `Download Statements of Results for ${count} selected student${count === 1 ? "" : "s"}?`,
            icon: "warning",
            showCancelButton: true,
            confirmButtonText: "Yes, Download",
            cancelButtonText: "Cancel",
            cancelButtonColor: tokens.colors.states.alert.default,
        });

        if (!confirmation.isConfirmed) {
            return;
        }

        const selectedStudents = selectedIds.map((studentId) => selectedStudentDetails[studentId]).filter(Boolean);
        const { wasCancelled, failedItems } = await runBulkQueue(selectedStudents, "Downloading Statements of Results", async (student) => {
            await handleDownloadSOR(student, { silent: true });
        });

        Swal.fire({
            icon: wasCancelled ? "info" : failedItems.length ? "warning" : "success",
            title: wasCancelled ? "Cancelled" : failedItems.length ? "Partially Completed" : "Success",
            text: wasCancelled
                ? "Remaining Statements of Results were not downloaded"
                : failedItems.length
                    ? `${failedItems.length} of ${selectedStudents.length} Statement${selectedStudents.length === 1 ? "" : "s"} of Results failed to download`
                    : "Download Successful",
        });
    };

    const hasActiveFilters = !!search || intake.arr.length > 0 || graduated.arr.length > 0;

    const fetchAllFilteredStudents = async () => {
        const payload = {
            id: queryProgrammeId,
            versionId: queryVersionId,
            key: "",
            sort: "DESC",
            exportStatus: "false",
            search: search,
            page: 1,
            limit: paginationState.total || 1,
            intake_year_number: intake.arr || [],
            graduation: graduated.arr || [],
            students: studentArr || [],
        };
        const studentListResponse = await getProgrammeModulesGradeStudentList(payload);
        return studentListResponse?.data?.data || [];
    };

    const applyConfirmModalButtonStyle = () => {
        const confirmButton = Swal.getConfirmButton();
        const cancelButton = Swal.getCancelButton();
        if (confirmButton) confirmButton.style.borderRadius = tokens.globals["border-radius"];
        if (cancelButton) cancelButton.style.borderRadius = tokens.globals["border-radius"];
    };

    const handleProgrammeCalculateFinalGrades = () => {
        const count = paginationState.total || 0;
        const text = hasActiveFilters
            ? `Filters are applied. Final grades will be calculated for the ${count} students matching the current filters – across all pages – not the full ${totalStudents} students in this programme.`
            : `Final grades will be calculated for all ${count} students in this programme. No filters are applied, so every student across all pages is included. Graduated students are skipped – graduation must be reversed before they can be recalculated.`;

        Swal.fire({
            title: "Calculate Final Grades?",
            text,
            showCancelButton: true,
            confirmButtonColor: "#2d64ad",
            cancelButtonColor: "#c43d51",
            confirmButtonText: `<i class="fal fa-sync" style="margin-right:6px"></i>Calculate ${count} Students`,
            cancelButtonText: `<i class="fal fa-times" style="margin-right:6px"></i>Cancel`,
            didOpen: applyConfirmModalButtonStyle,
        }).then(async (confirmation) => {
            if (!confirmation.isConfirmed) {
                return;
            }

            const students = await fetchAllFilteredStudents();
            const calculatedIds = students.map((student) => student.id);
            const { wasCancelled, failedItems } = await runBulkQueue(calculatedIds, "Calculating grades", calculateStudentGrade);

            setUpdateValueArr((prevState) => prevState.filter((change) => !calculatedIds.includes(change.student_id)));

            if (!wasCancelled && !failedItems.length) {
                setBulkSuccessMessage("Grades Calculated Successfully");
                studentGradeListQuery.refetch();
                return;
            }

            Swal.fire({
                icon: wasCancelled ? "info" : "warning",
                title: wasCancelled ? "Cancelled" : "Partially Completed",
                text: wasCancelled
                    ? "Remaining students were not calculated"
                    : `${failedItems.length} of ${calculatedIds.length} student${calculatedIds.length === 1 ? "" : "s"} failed to calculate`,
            }).then(() => studentGradeListQuery.refetch());
        });
    };

    const handleProgrammeDownloadSOR = () => {
        const count = paginationState.total || 0;
        const text = hasActiveFilters
            ? `Statements of Results will be generated for the ${count} students matching the current filters, across all pages. Exported documents show the programme-level result as Graduated / Not graduated; module marks are included.`
            : `Statements of Results will be generated for all ${count} students in this programme. No filters are applied, so every student across all pages is included. Exported documents show the programme-level result as Graduated / Not graduated; module marks are included.`;

        Swal.fire({
            title: "Download Statements of Results?",
            text,
            showCancelButton: true,
            confirmButtonColor: "#2d64ad",
            cancelButtonColor: "#c43d51",
            confirmButtonText: `<i class="fal fa-download" style="margin-right:6px"></i>Download ${count} SORs`,
            cancelButtonText: `<i class="fal fa-times" style="margin-right:6px"></i>Cancel`,
            didOpen: applyConfirmModalButtonStyle,
        }).then(async (confirmation) => {
            if (!confirmation.isConfirmed) {
                return;
            }

            const students = await fetchAllFilteredStudents();
            const { wasCancelled, failedItems } = await runBulkQueue(students, "Downloading Statements of Results", async (student) => {
                await handleDownloadSOR(student, { silent: true });
            });

            Swal.fire({
                icon: wasCancelled ? "info" : failedItems.length ? "warning" : "success",
                title: wasCancelled ? "Cancelled" : failedItems.length ? "Partially Completed" : "Success",
                text: wasCancelled
                    ? "Remaining Statements of Results were not downloaded"
                    : failedItems.length
                        ? `${failedItems.length} of ${students.length} Statement${students.length === 1 ? "" : "s"} of Results failed to download`
                        : "Download Successful",
            });
        });
    };

    const exportDisabledReason = loading.list
        ? "Rows are still loading"
        : !userData?.length
            ? "No rows match the current filters"
            : saveGradesLoading
                ? "A calculation is currently running"
                : "";
    const isExportDisabled = !!exportDisabledReason;
    const isCalculatingBulk = saveGradesLoading && bulkProgress?.actionLabel === "Calculating grades";

    const paginationDisabled = saveGradesLoading || loading.list;
    const paginationDisabledReason = saveGradesLoading ? "A calculation is already running" : "Rows are loading";
    const paginationTotalPages = Math.max(1, paginationState.lastPage || 1);
    const paginationCurrentPage = Math.min(Math.max(1, paginationState.currentPage || 1), paginationTotalPages);
    const paginationAtFirst = paginationCurrentPage <= 1;
    const paginationAtLast = paginationCurrentPage >= paginationTotalPages;
    const paginationHasEntries = paginationState.total > 0;
    const paginationDisplayStart = paginationHasEntries ? Math.max(1, paginationState.from || 1) : 0;
    const paginationDisplayEnd = paginationHasEntries
        ? Math.min(paginationState.to || paginationState.total, paginationState.total)
        : 0;

    const handlePaginationPageChange = (page) => {
        if (paginationDisabled) {
            return;
        }
        const targetPage = Math.min(Math.max(1, page), paginationTotalPages);
        if (updateValueArr?.length) {
            const keyword =
                targetPage === 1
                    ? "firstPage"
                    : targetPage === paginationState.lastPage
                        ? "lastPage"
                        : targetPage > (paginationState.currentPage || 1)
                            ? "nextPage"
                            : "prevPage";
            handleNavigation(null, keyword);
        } else {
            setTableState((prevState) => ({ ...prevState, page: targetPage }));
        }
    };

    return (
        <>
            {exportModalOpen && (
                <ModalOverlay>
                    <ModalContainer role="dialog" aria-modal="true">
                        <CloseButton
                            type="button"
                            onClick={closeExportModal}
                        >
                            <i className="fal fa-times"></i>
                        </CloseButton>
                        <ModalHeader>
                            <ModalTitle>Export Grade Reports</ModalTitle>
                            <ModalDescription>
                                This exports a report of student grades from the selected intake origins along the study path. It reads the gradebook and may take a minute to finish. Please keep this window open until the export is complete.
                            </ModalDescription>
                            <FieldGroup>
                                <FieldLabel>Include Origin Intakes</FieldLabel>
                                <Select
                                    isMulti
                                    isDisabled={exportGenerating}
                                    isLoading={exportIntakeLoading}
                                    isClearable={false}
                                    options={exportIntakeOptions}
                                    value={exportSelectedIntakes}
                                    components={{ MultiValueRemove }}
                                    onChange={(selected) => setExportSelectedIntakes(selected || [])}
                                    placeholder="Select intakes..."
                                    styles={multiSelectStyles}
                                />
                            </FieldGroup>
                            <TogglesRow>
                                <ToggleSwitch
                                    checked={exportIncludeNonWeighted}
                                    disabled={exportGenerating}
                                    label="Include non-weighted assessments"
                                    onChange={() => setExportIncludeNonWeighted((value) => !value)}
                                />

                                <ToggleSwitch
                                    checked={exportIncludeRedo}
                                    disabled={exportGenerating}
                                    label="Include Redo Module Sheet"
                                    onChange={() => setExportIncludeRedo((value) => !value)}
                                />
                            </TogglesRow>

                            {exportError && <ErrorMessage>{exportError}</ErrorMessage>}
                        </ModalHeader>
                        <ModalFooter>
                            <Button
                                type="button"
                                variant="primary"
                                disabled={!exportSelectedIntakes.length || exportGenerating}
                                onClick={handleGenerateExport}
                            >
                                {exportGenerating ? 'Generating…' : 'Generate Export'}
                            </Button>
                            <CancelButton type="button" onClick={closeExportModal}>
                                <i className="fal fa-times"></i> Cancel
                            </CancelButton>
                        </ModalFooter>
                    </ModalContainer>
                </ModalOverlay>
            )}
            <Prompt when={!!shouldBlockNavigation} message={handleNavigation} />
            <div className="my-tickets-info-list Tickets-main-wrap course-gradebook">
                <SummaryStrip
                    versionName={props?.versionData?.name}
                    isActiveVersion={props?.isActiveVersion}
                    isVersionLocked={isVersionLocked}
                    coordinator={qcCoordinator}
                    totals={summaryTotals}
                    isLoading={summaryTotalsLoading}
                    isCalculating={isCalculatingBulk}
                    isBusy={saveGradesLoading || loading.heading || loading.list}
                    onCalculateFinalGrades={handleProgrammeCalculateFinalGrades}
                    onDownloadSOR={handleProgrammeDownloadSOR}
                    downloadDisabled={isExportDisabled}
                    updatedAt={qualifications?.grade_update_datetime}
                    updatedByName={qualifications?.updatedby_name}
                />
                {bulkProgress && (
                    <BulkProgressWrapper>
                        <ProgressCard
                            label={bulkProgress.actionLabel}
                            current={Math.min(bulkProgress.completed + 1, bulkProgress.total)}
                            total={bulkProgress.total}
                            unit={bulkProgress.total === 1 ? "Student" : "Students"}
                            onCancel={handleCancelBulkProgress}
                            cancelDisabled={bulkProgress.cancelRequested}
                        />
                    </BulkProgressWrapper>
                )}
                {bulkSuccessMessage && (
                    <BulkProgressWrapper>
                        <GradebookSuccessBanner
                            message={bulkSuccessMessage}
                            onDismiss={() => setBulkSuccessMessage(null)}
                        />
                    </BulkProgressWrapper>
                )}
                <GradebookCardBlock>
                    <SearchFilterBar className="search-filter-div">
                        <div className="search-filter-div-left">
                            <FilterToolbarRow>
                                <SearchBox>
                                    <SearchIcon className="fal fa-search" />
                                    <SearchInput
                                        type="search"
                                        placeholder="Search"
                                        aria-controls="assessment-table-main"
                                        onChange={handleSearchFilter}
                                        value={debouncedTerm}
                                    />
                                </SearchBox>
                                <Tablefilter
                                    filterName="Intake"
                                    optionArr={filterData.intake}
                                    state={intake}
                                    setState={setIntake}
                                    btnStyleOverride={intake.arr.length ? filterDropdownButtonActiveStyle : filterDropdownButtonStyle}
                                    isDisabled={saveGradesLoading}
                                />
                                <Tablefilter
                                    filterName="Graduated"
                                    optionArr={filterData.graduated}
                                    state={graduated}
                                    setState={setGraduated}
                                    btnStyleOverride={graduated.arr.length ? filterDropdownButtonActiveStyle : filterDropdownButtonStyle}
                                    isDisabled={saveGradesLoading}
                                />
                                <ResetButton type="button" title="Reset" onClick={resetFilter} disabled={saveGradesLoading}>
                                    Reset
                                    <i className="fal fa-undo"></i>
                                </ResetButton>
                                <ExportButtonGroup>
                                    <ExportButton
                                        type="button"
                                        title={isExportDisabled ? exportDisabledReason : "Export spreadsheet"}
                                        disabled={isExportDisabled}
                                        onClick={() => {
                                            exportXlsxData(
                                                `${props?.versionData?.name} Grade Book`,
                                                props?.versionData?.name
                                            );
                                        }}
                                    >
                                        <i className="fal fa-file-excel icon-default"></i>
                                        <i className="fas fa-file-excel icon-hover"></i>
                                    </ExportButton>
                                    <ExportButton
                                        type="button"
                                        title={isExportDisabled ? exportDisabledReason : "Export CSV"}
                                        disabled={isExportDisabled}
                                        onClick={() => {
                                            exportData("csv", `${props?.versionData?.name} Grade Book`);
                                        }}
                                    >
                                        <i className="fal fa-file-csv icon-default"></i>
                                        <i className="fas fa-file-csv icon-hover"></i>
                                    </ExportButton>
                                    <ExportButton
                                        type="button"
                                        title={isExportDisabled ? exportDisabledReason : "Export PDF"}
                                        disabled={isExportDisabled}
                                        onClick={() => {
                                            exportData("pdf", `${props?.versionData?.name} Grade Book`);
                                        }}
                                    >
                                        <i className="fal fa-file-pdf icon-default"></i>
                                        <i className="fas fa-file-pdf icon-hover"></i>
                                    </ExportButton>
                                </ExportButtonGroup>
                                <div style={{ marginLeft: "auto" }}>
                                    <PermissionsGate
                                        scopes={["pmcgradebookexport"]}
                                        errorProps={{ disabled: true, title: "You do not have permission to access this function" }}
                                    >
                                        <Button
                                            type="button"
                                            variant="accent"
                                            title="Export Grade Report"
                                            onClick={openExportModal}
                                        >
                                            <i className="fal fa-bar-chart"></i>
                                            Export Grade Report
                                        </Button>
                                    </PermissionsGate>
                                </div>
                            </FilterToolbarRow>
                        </div>
                    </SearchFilterBar>
                    <GradebookTable
                        isLoading={loading.heading || loading.listInitial}
                        data={sortedUserData}
                        moduleHeader={moduleHeader}
                        paginationTotal={paginationState.total}
                        selectedIds={selectedIds}
                        selectAllLoading={selectAllLoading}
                        isBusy={saveGradesLoading}
                        calculatingStudentId={calculatingStudentId}
                        sortConfig={sortConfig}
                        onSort={handleSort}
                        onToggleSelectAll={toggleSelectAll}
                        onToggleSelectRow={toggleSelectRow}
                        onExemptionToggle={handleExemption}
                        onSaveSingleGrade={handleSingleGradeCalculation}
                        onDownloadSOR={handleDownloadSOR}
                        tableScrollRef={tableScrollRef}
                        scrollbarProxyRef={scrollbarProxyRef}
                    />
                    <GradebookPaginationFooter
                        aria-label="Table pagination"
                        aria-disabled={paginationDisabled || undefined}
                        title={paginationDisabled ? paginationDisabledReason : undefined}
                    >
                        <GradebookPaginationAmountText>
                            Showing {paginationDisplayStart} to {paginationDisplayEnd} of {paginationState.total} entries
                        </GradebookPaginationAmountText>

                        <GradebookPaginationRight>
                            <GradebookPaginationRowsPerPage>
                                Rows per page
                                <GradebookPaginationSelect
                                    value={tableState.limit}
                                    onChange={(event) => {
                                        const value = Number(event.target.value);
                                        setTableState((prevState) => ({
                                            ...prevState,
                                            limit: value || 10,
                                            page: 1,
                                        }));
                                    }}
                                    disabled={paginationDisabled}
                                    aria-label="Rows per page"
                                >
                                    {TABLE_ROWS_PER_PAGE.map((option) => (
                                        <option key={option} value={option}>{option}</option>
                                    ))}
                                </GradebookPaginationSelect>
                            </GradebookPaginationRowsPerPage>

                            <GradebookPaginationPageText>
                                Page {paginationCurrentPage} of {paginationTotalPages}
                            </GradebookPaginationPageText>

                            <GradebookPaginationControls>
                                <GradebookPaginationPageButton
                                    type="button"
                                    onClick={() => handlePaginationPageChange(1)}
                                    disabled={paginationDisabled || paginationAtFirst}
                                    aria-label="First page"
                                >
                                    <i className="fal fa-chevrons-left" aria-hidden="true" />
                                </GradebookPaginationPageButton>
                                <GradebookPaginationPageButton
                                    type="button"
                                    onClick={() => handlePaginationPageChange(paginationCurrentPage - 1)}
                                    disabled={paginationDisabled || paginationAtFirst}
                                    aria-label="Previous page"
                                >
                                    <i className="fal fa-chevron-left" aria-hidden="true" />
                                </GradebookPaginationPageButton>
                                <GradebookPaginationPageButton
                                    type="button"
                                    onClick={() => handlePaginationPageChange(paginationCurrentPage + 1)}
                                    disabled={paginationDisabled || paginationAtLast}
                                    aria-label="Next page"
                                >
                                    <i className="fal fa-chevron-right" aria-hidden="true" />
                                </GradebookPaginationPageButton>
                                <GradebookPaginationPageButton
                                    type="button"
                                    onClick={() => handlePaginationPageChange(paginationTotalPages)}
                                    disabled={paginationDisabled || paginationAtLast}
                                    aria-label="Last page"
                                >
                                    <i className="fal fa-chevrons-right" aria-hidden="true" />
                                </GradebookPaginationPageButton>
                            </GradebookPaginationControls>
                        </GradebookPaginationRight>
                    </GradebookPaginationFooter>
                </GradebookCardBlock>
                {selectedIds.length > 0 && (
                    <FloatingActionBar
                        ariaLabel="Gradebook bulk actions"
                        summary={selectAllLoading ? "Selecting Students" : `${selectedIds.length} Student${selectedIds.length === 1 ? "" : "s"} Selected`}
                    >
                        <Button
                            variant="accent"
                            size="lg"
                            type="button"
                            title={
                                selectAllLoading
                                    ? "Still selecting all matching students"
                                    : isCalculatingBulk
                                        ? "Calculation is running"
                                        : saveGradesLoading
                                            ? "A calculation is already running"
                                            : "Calculate Final Grades"
                            }
                            disabled={saveGradesLoading || selectAllLoading}
                            onClick={handleBulkGradeCalculation}
                        >
                            <i
                                className={isCalculatingBulk ? "fal fa-circle-notch fa-spin" : "fal fa-sync"}
                                style={isCalculatingBulk ? { color: tokens.colors.brand.blue["500"] } : undefined}
                            ></i>
                            {isCalculatingBulk ? "Calculating Grades..." : "Calculate Final Grades"}
                        </Button>
                        <Button
                            variant="primary"
                            size="lg"
                            type="button"
                            title={
                                selectAllLoading
                                    ? "Still selecting all matching students"
                                    : saveGradesLoading
                                        ? "A calculation is already running"
                                        : "Download Statement of Results for selected students"
                            }
                            disabled={saveGradesLoading || selectAllLoading}
                            onClick={handleBulkDownloadSOR}
                        >
                            <i className="fal fa-download"></i>
                            Download SOR
                        </Button>
                    </FloatingActionBar>
                )}
            </div>
        </>
    );
}

export default PMCGradeBook;
